import {registerPlugin} from '@capacitor/core';

export const ForegroundServicePlugin = registerPlugin<{
    startForegroundService: (input: {title: string}) => Promise<void>;
    stopForegroundService: () => Promise<void>;
}>('ForegroundService');
